import { getRequest } from "../../../../api/client";
import { getTrashScheduleApi } from "../../../../Endpoints";
import { AddressPointModel } from "../../filters/models/AddressPointModel";
import { TrashScheduleModel } from "../../models/TrashScheduleModel";

export type TrashScheduleQueryParams = Pick<AddressPointModel, "id">;

export const getTrashSchedule = async (building: TrashScheduleQueryParams) => {
  return getRequest<TrashScheduleModel>(`${getTrashScheduleApi(building.id)}`);
};
